export namespace Search {
    export const init = () => {
        // ----- Header Search Bar Logic ----- //

        let searchBar = document.getElementById('js-headerSearchBar');
        let searchButton = document.getElementById('js-headerSearchButton');

        if (searchButton && searchBar) {
            searchButton.addEventListener('click', function() {
                let searchBarValue = (<HTMLInputElement>searchBar).value;
                if (searchBarValue.length > 0) {
                    buildUrl(searchBarValue);
                }
            });
            searchBar.addEventListener('keypress', function(e) {
                let searchBarValue = (<HTMLInputElement>searchBar).value;

                if (e.key == "Enter" && searchBarValue.length > 0) {
                    buildUrl(searchBarValue);
                }
            });
        }

        function buildUrl(searchBarValue) {
            let builtUrl = "/search-results?FilterCriteria.Query=" + searchBarValue;
            location.assign(builtUrl);
        }

        // ----- Search Results Checkboxes/Radio Button Logic ----- //

        let urlParameters = window.location.search;
        let urlPath = window.location.pathname;
        let corporateCheckbox = document.getElementById('corporate');
        let steelCheckbox = document.getElementById('steel');
        let hccCheckbox = document.getElementById('hcc');
        let pageRadio = document.getElementById('pages');
        let docRadio = document.getElementById('documents');
        let newsEventsRadio = document.getElementById('newsAndEvents');

        // If page Url include "search-results" in the path name...
        if (urlPath.includes('search-results')) {
            // If Url parameteres do not include "IsCorporate", "IsSteel", and "IsHcc"...
            if (!urlParameters.includes('IsCorporate') && !urlParameters.includes('IsSteel') && !urlParameters.includes('IsHcc')) {
                // Check all the site filter checkboxes
                (<HTMLInputElement>corporateCheckbox).checked = true;
                (<HTMLInputElement>steelCheckbox).checked = true;
                (<HTMLInputElement>hccCheckbox).checked = true;
            } else {
                // If Url parameters only include "IsCorporate"...
                if (!urlParameters.includes('IsCorporate')) {
                    // Check Corporate site filter checkbox
                    (<HTMLInputElement>corporateCheckbox).checked = false;
                }
        
                // If Url parameters only include "IsSteel"...
                if (!urlParameters.includes('IsSteel')) {
                    // Check Steel site filter checkbox
                    (<HTMLInputElement>steelCheckbox).checked = false;
                }
        
                // If Url parameters only include "IsHcc"...
                if (!urlParameters.includes('IsHcc')) {
                    // Check HCC site filter checkbox
                    (<HTMLInputElement>hccCheckbox).checked = false;
                }
            }

            // If Url parameters include "ContentType=1"...
            if (urlParameters.includes('ContentType=1')) {
                // Check the Document fitler checkbox
                (<HTMLInputElement>docRadio).checked = true;
            // Else If Url parameters include "ContentType=2"...
            } else if (urlParameters.includes('ContentType=2')) {
                // Check the News and Events filter checkbox
                (<HTMLInputElement>newsEventsRadio).checked = true;
            } else {
                // Check the Pages filter checkbox
                (<HTMLInputElement>pageRadio).checked = true;
            }
        }
    }
}